module.exports = __webpack_public_path__ + "static/media/6625.32f5b068.jpg";